import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import _ from "lodash";
import {Button} from "../Button";
import {CheckboxInputField, TextInputField} from "../FormField";
import {createForumTopic, fetchForumTopic, resetForumTopic, updateForumTopic} from "../../../creators/forums.topic";
import {config} from "../../../config";
import Modal from "../Modal";
import MkEditor from "../editor/Editor";
import DraftContentReader from "../editor/DraftContentReader";
import {PageLoader} from "../Loader";

class AdvancedEditorTopic extends React.Component {
    constructor(props){
        super(props);
        this.initialTopic = {
            title: this.props.title || "",
            tags: this.props.tags || [],
            contentRaw: this.props.contentRaw || "",
            useSign: _.get(this.props.currentUser,"setting.signature.display"),
            // isFollow: false
        };
        this.state = {
            topic: this.initialTopic,
            addTag: '',
            toggleSurvey: false,
            showPreview: false,
        };
        this.handleValue = this.handleValue.bind(this);
        // this.handleAddTag = this.handleAddTag.bind(this);
        // this.removeTags = this.removeTags.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitMessageTimeout = this.handleSubmitMessageTimeout.bind(this);

        this.editorRef = React.createRef();

        if(this.props.topicId){
            this.props.fetchForumTopic(this.props.topicId, {nocache : true});
        }
        // else {
        //     this.props.createForumTopic(this.props.forumId);
        // }
    }

    componentWillUnmount() {
        if(!this.props.topicId){
            this.props.resetForumTopic();
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.forumTopic !== this.props.forumTopic && this.props.topicId){
            this.setState({topic: {
                    ...this.state.topic,
                    title: this.props.forumTopic.title,
                    tags: this.props.forumTopic.tags,
                    contentRaw: this.props.forumTopic.contentRaw,
                    // isFollow: this.props.forumTopic.isFollow,
                    useSign: this.props.forumTopic.useSign,
            }});
            console.log(this.props.forumTopic);
        }
    }

    handleValue(name, value){
        this.setState({topic : {...this.state.topic, [name] : value}});
    }

    // handleAddTag(event) {
    //     this.setState({addTag: event.target.value})
    // }
    //
    // removeTags(currentIndex) {
    //     let tags = this.state.topic.tags;
    //     tags.splice(currentIndex, 1);
    //     this.setState({topic: {...this.state.topic, tags}});
    //     if (typeof (this.props.handleTags) !== "undefined") {
    //         this.props.handleTags(tags);
    //     }
    // }

    handleKeyPress(event) {
        if (event.key === "Enter" && this.state.addTag.length >= 1 && this.state.topic.tags.length <= 9) {
            let tags = [...this.state.topic.tags, {name: this.state.addTag}];
            this.setState({addTag: "", topic : {...this.state.topic, tags}});
            if (typeof (this.props.handleTags) !== "undefined") {
                this.props.handleTags(tags);
            }
        }
    }

    handleSubmit(){
        setTimeout(()=>{
            this.handleSubmitMessageTimeout();
        },50)
    }

    handleSubmitMessageTimeout(){
        let hasText = this.editorRef.current.handleHasText();
        if(this.state.topic.title.length >= 1 && hasText) {
            let files = {};
            let contentRaw = this.state.topic.contentRaw;
            if (this.state.topic.contentRaw && this.state.topic.contentRaw.entityMap) {
                // files = {
                //     ...files,
                //     "contentRaw.entityMap" : Object.values(this.state.article.contentRaw.entityMap)
                // };
                let contentFiles = Object.values(this.state.topic.contentRaw.entityMap);
                contentFiles.forEach((item, index) => {
                    if (item.type === "UPLOADED_MEDIA") {
                        let key = `contentRaw.entityMap[${index}].data.uri`;
                        files = {
                            ...files,
                            [key]: item.data.id
                        };
                        if (contentRaw.entityMap[index].data && contentRaw.entityMap[index].data.id) {
                            delete contentRaw.entityMap[index].data.id;
                        }
                    }
                });
            }
            if (this.props.forumId && this.props.topicId) {
                this.props.updateForumTopic(this.props.forumId, this.props.topicId, {
                    ...this.state.topic,
                    contentRaw,
                    "_files": files
                });
            } else {
                this.props.createForumTopic(this.props.forumId, {...this.state.topic, contentRaw, "_files": files});
            }
            this.props.resetForumTopic();
            this.props.handleClose();
        }
        if (!hasText) {
            this.setState({contentError: true});
        } else {
            this.setState({contentError: false});
        }

        if (this.state.topic.title.length === 0) {
            this.setState({titleError: true});
        } else {
            this.setState({titleError: false});
        }
    }

    render(){

        return (this.props.topicId && this.props.forumTopicLoading) ? (
            <div className={"advanced-editor topic modal-container"}>
                <PageLoader />
            </div>
        ) : (
            <div className={"advanced-editor topic modal-container"}>
                <div className={"modal-topline"}>
                    <div>{this.props.topicId ? `Edition du topic : ${this.state.topic.title}` : "Création d'un topic"}</div>
                </div>
                <div className={"modal-body"}>
                    <div className={"main"}>
                        <div className={"inner-block"}>
                            <span className={"input-label"}>Titre</span>
                            <TextInputField value={this.state.topic.title}
                                            placeholder={"Titre de votre sujet"}
                                            error={this.state.titleError}
                                            onChange={(event)=>this.handleValue("title", event.target.value)} />
                        </div>

                        {/*<div className={"inner-block"}>*/}
                        {/*    <span className={"input-label"}>Étiquettes du sujet</span>*/}
                        {/*    <div className="row align-flex-end full add-tag-container">*/}
                        {/*        {this.state.topic.tags.length < 10 && (<input*/}
                        {/*            type="text"*/}
                        {/*            className="bottom-bar-style"*/}
                        {/*            placeholder="Ecrivez votre tag ici ..."*/}
                        {/*            value={this.state.addTag}*/}
                        {/*            onChange={(event) => this.handleAddTag(event)}*/}
                        {/*            onKeyPress={(event) => this.handleKeyPress(event)}*/}
                        {/*            maxLength="29"*/}
                        {/*            minLength="1"*/}
                        {/*        />)}*/}
                        {/*        {this.state.topic.tags.length < 10 && (<span*/}
                        {/*            className={`row no-shrink max-characters mx-4 ${this.state.addTag.length === 29 ? 'max-reached' : ''}`}>({this.state.addTag.length} / 29 caractères)</span>)}*/}
                        {/*        <TagList className="classic" tags={this.state.topic.tags}*/}
                        {/*                 removeTags={this.removeTags}/>*/}
                        {/*    </div>*/}
                        {/*    <span className="max-tag">Sélectionner au maximum 10 étiquettes ({this.state.topic.tags.length} / 10)</span>*/}
                        {/*</div>*/}

                        <div className={"inner-block"}>
                            <span className={"input-label"}>Contenu de la publication</span>
                            {this.props.topicId ? (
                                <MkEditor onChange={(contentRaw) => this.setState({topic: {...this.state.topic, contentRaw}})}
                                          ref={this.editorRef}
                                          className={this.state.contentError ? "error" : ""}
                                          kind={"topic"}
                                          defaultValue={this.state.topic.contentRaw || this.props.forumTopic.contentRaw}/>
                            ) : (
                                <MkEditor onChange={(contentRaw) => this.setState({topic: {...this.state.topic, contentRaw}})}
                                          ref={this.editorRef}
                                          className={this.state.contentError ? "error" : ""}
                                          kind={"topic"}/>
                            )}
                        </div>
                    </div>
                    <div className="sidebar">
                        <div className="advanced-editor-block">
                            <h4>Options du message</h4>
                            <div className="advanced-editor-content">
                                <CheckboxInputField checked={this.state.topic.useSign}
                                                    onChange={() => this.handleValue("useSign", !this.state.topic.useSign)}
                                                    id={"useSign"}
                                                    htmlFor={"useSign"}
                                                    label={"Inclure ma signature"}/>

                                {/*<CheckboxInputField checked={this.state.topic.isFollow}*/}
                                {/*                    onChange={() => this.handleValue("isFollow", !this.state.topic.isFollow)}*/}
                                {/*                    id={"isFollow"}*/}
                                {/*                    htmlFor={"isFollow"}*/}
                                {/*                    label={"Suivre ce sujet"}/>*/}
                            </div>
                        </div>

                        {/*<div className="advanced-editor-block">*/}
                        {/*    <h4>Options d'éditions</h4>*/}
                        {/*    <div className="advanced-editor-content">*/}
                        {/*        <div className="row">*/}
                        {/*            <input type="checkbox" id="addModifyBy"*/}
                        {/*                   onChange={() => this.props.handleDisplayMessage()}*/}
                        {/*                   checked={this.props.displayMessage || false}/> <label*/}
                        {/*            htmlFor="addModifyBy">Ajouter la ligne "modifié par" dans ce message*/}
                        {/*            ?</label>*/}
                        {/*        </div>*/}
                        {/*        <div className="column">*/}
                        {/*            <label>Raison d'édition :</label>*/}
                        {/*            <textarea value={this.props.reason}*/}
                        {/*                      onChange={(event) => this.props.handleReason(event.target.value)}/>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                    </div>
                </div>
                <div className={"modal-baseline"}>
                    {(this.state.titleError || this.state.contentError) && (
                        <span className={"red"}>Vous n'avez pas complété tous les champs</span>
                    )}
                    <Button btnStyle={"grey"}
                            size={"small"}
                            onClick={()=>this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button btnStyle={"primary-reverse"}
                            size={"small"}
                            onClick={()=>this.setState({showPreview: true})}
                            content={"Prévisualiser"}/>
                    <Button btnStyle={"primary-reverse"}
                            onClick={()=>this.handleSubmit()}
                            loading={this.props.forumTopicSubmitting}
                            size={"small"}
                            content={ this.props.topicId ? "Editer" : "Publier"}/>
                </div>
                <Modal toggle={this.state.showPreview} handleClose={()=>this.setState({showPreview: false})}>
                    <div className={"modal-container topic-preview container"}>
                        <div className={"modal-topline"}>
                            Prévisualisation du message de votre sujet
                        </div>
                        <div className={"modal-body"}>
                            <div className={"first-message"}>
                                <span className={`first-message-label ${config.genderClass[this.props.currentUser.profile.gender]}`}>Message du sujet :</span>
                                <div className={"content"}>
                                    <DraftContentReader contentRaw={this.state.topic.contentRaw} />
                                </div>
                            </div>
                        </div>
                        <div className={"modal-baseline"}>
                            <Button onClick={()=>this.setState({showPreview: false})}
                                    btnStyle={"primary-reverse"}
                                    size={"small"}
                                    content={"Quitter"}/>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        forumTopic: state.forumTopic.data,
        forumTopicLoading: state.forumTopic.loading,
        forumTopicInitialized: state.forumTopic.initialized,
        forumTopicSubmitting: state.forumTopic.submitting,

        currentUser: state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumTopic,
    resetForumTopic,
    createForumTopic,
    updateForumTopic
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(AdvancedEditorTopic);